import React, {useContext, useEffect, useMemo, useState} from 'react';
import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {Button, Table} from 'antd';
import {HolderOutlined} from "@ant-design/icons";
import '../../styles/table.scss';

const RowContext = React.createContext({});

const DragHandle = () => {
  const {setActivatorNodeRef, listeners} = useContext(RowContext);

  return (
    <Button
      type="text"
      size="small"
      icon={<HolderOutlined/>}
      style={{
        cursor: 'move',
      }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

const Row = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props['data-row-key'],
  });
  const style = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging
      ? {
        position: 'relative',
        zIndex: 9999,
      }
      : {}),
  };
  const contextValue = useMemo(
    () => ({
      setActivatorNodeRef,
      listeners,
    }),
    [setActivatorNodeRef, listeners],
  );
  return (
    <RowContext.Provider value={contextValue}>
      <tr {...props} ref={setNodeRef} style={style} {...attributes} />
    </RowContext.Provider>
  );
};

const DndTable = ({ initialData, columns, onUpdate }) => {
  const [dataSource, setDataSource] = useState([]);
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setDataSource((prevState) => {
        const activeIndex = prevState.findIndex((record) => record.key === active?.id);
        const overIndex = prevState.findIndex((record) => record.key === over?.id);
        const newDataSource = arrayMove(prevState, activeIndex, overIndex);
        onUpdate(newDataSource);
        return newDataSource;
      });
    }
  };

  useEffect(() => {
    setDataSource(initialData);
  }, [initialData]);

  return (
    <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
      <SortableContext items={dataSource.map((i) => i.key)} strategy={verticalListSortingStrategy}>
        <Table
          className="custom-table-scroll"
          rowKey="key"
          components={{
            body: {
              row: Row,
            },
          }}
          pagination={false}
          scroll={{
            x: 550,
            y: 180,
          }}
          style={{ height: 250 }}
          columns={columns}
          dataSource={dataSource}
        />
      </SortableContext>
    </DndContext>
  );
};

export { DndTable, DragHandle };